import { createContext } from "react";

const AssetsContext = createContext();

export { AssetsContext };
